import React, { useState } from 'react';
import { OverlayContainer } from '@react-aria/overlays';

import {
  FilterModalHeader,
  FilterSortOrder,
  FilterSearchBar,
  FilterModalOptions,
} from 'src/pages/CatalogPage/components/FilterMenu/CaliberFilterModal/FilterModal.style';
import { Modal, ModalContentArea } from '@riac/design-system';
import { InvertedRadioOption } from 'src/components/Input/RadioInput/InvertedRadioInput';
import { Input } from '@riac/design-system';
import { XButton } from '@riac/design-system';
import { BoxButton } from '@riac/design-system';

import { IMapping } from 'src/pages/CatalogPage/Catalog.i';
import { TFacet } from 'src/pages/CatalogPage/CatalogPage.i';


interface ICaliberModal {
  changeFilter(slug: string, field: string): void;
  close(): void;
  subcalMappings: IMapping[];
  cal: string;
  subcal: string;
  facets: TFacet;
}

export const CaliberFilterModal = (props: ICaliberModal) => {
  const [searchInput, setSearchInput] = useState('');
  const [sortAlpha, setSortAlpha] = useState(true);

  function handleInput(val) {
    setSearchInput(val);
  }

  function closeModal() {
    props.close();
  }

  function clearSearch() {
    setSearchInput('');
  }

  if(props.subcalMappings.length === 0) {
    return null;
  }
  const calFilteredList = Object.keys(props.facets).filter((cal) =>
    cal.toLowerCase().trim().includes(searchInput.toLowerCase().trim())
  );

  return (
    <OverlayContainer>
      <Modal
        isOpen={true}
        onClose={closeModal}
        showCloseButton
        isDismissable
        title='Filter By Caliber'
        fullHeight
      >
        <ModalContentArea>
          <FilterModalHeader>
            <FilterSortOrder>
              <InvertedRadioOption
                value='alpha'
                onChange={() => setSortAlpha(true)}
                name='sort'
                checked={sortAlpha}
              >
                Sort alphanumerically
              </InvertedRadioOption>
              <InvertedRadioOption
                value='num'
                onChange={() => setSortAlpha(false)}
                name='sort'
                checked={!sortAlpha}
              >
                Sort by most popular
              </InvertedRadioOption>
            </FilterSortOrder>
            <FilterSearchBar>
              <Input
                type='text'
                value={searchInput}
                placeholder='Filter Results'
                aria-label='Filter Results'
                inverted
                onChange={handleInput}
              />
              <BoxButton onPress={clearSearch}>Clear</BoxButton>
            </FilterSearchBar>
            <span style={{ visibility: props.cal ? 'visible' : 'hidden' }}>
              {`Currently viewing ${props.cal}'s`}
              <XButton
                onPress={() => {
                  props.changeFilter('', 'caliber');
                }}
              />
            </span>
          </FilterModalHeader>
          <FilterModalOptions>
            {calFilteredList
              .filter((cal) => props.facets[cal] > 0)
              .filter((cal) => cal !== 'N/A')
              .sort(
                sortAlpha
                  ? undefined
                  : (a, b) => {
                    return props.facets[b] - props.facets[a];
                  }
              )
              .slice()
              .map((subcal) => {
                const subcaliber = props.subcalMappings.filter(
                  (mapping) => mapping.value.trim() === subcal.trim()
                )[0];
                if(!subcaliber) {
                  return null;
                }
                const count = props.facets[subcaliber.value.trim()] || '0' || 1;
                if(count > 0) {
                  return (
                    <div key={subcaliber.value}>
                      <InvertedRadioOption
                        name='subcal_modal'
                        checked={props.subcal === subcaliber.value}
                        value={subcaliber.value}
                        onChange={() => {
                          props.changeFilter(subcaliber.slug, 'subcaliber');
                          closeModal();
                        }}
                      >
                        {subcaliber.name} ({count})
                      </InvertedRadioOption>
                    </div>
                  );
                }
              })}
          </FilterModalOptions>
        </ModalContentArea>
      </Modal>
    </OverlayContainer>
  );
};
